import React, { useState, useEffect } from "react";
import AppHorizontalLogo from "../../../images/logo-white-horizontal.png";
import localeText from "../../../../locale";
import PrimaryBannerImg from "../../../images/pages/ad-banner1.png";
import "./styles.css";
import BannerCarousel from "../BannerCarousel/BannerCarousel";
import BestDeals from "../BestDeals/BestDeals";
import GetInfoService from "../../../../service/GetInfoService";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { locale } from "../../../../utilities/locale/locale";
import Loading from "../../../../components/Loading/Loading";
import { Skeleton } from "primereact/skeleton";
import useLoadingSimulation from "../../hooks/useLoadingSimulation";

const PrimaryBanner = () => {
  const [primaryBanner, setPrimaryBanner] = useState([]);
  const [subBannerOne, setSubBannerOne] = useState([]);
  const [subBannerTwo, setSubBannerTwo] = useState([]);
  const [subBannerThree, setSubBannerThree] = useState([]);
  const [loading, setLoading] = useState(true);
  const isLoadingSimulation = useLoadingSimulation();

  const getInfoService = new GetInfoService();

  const bannerLang = {
    pt: "imageDesktopPortuguese",
    en: "imageDesktopEnglish",
    it: "imageDesktopItalian",
    es: "imageDesktopSpanish",
  };

  useEffect(() => {
    const getBanners = async () => {
      const response = await getInfoService.getConfiguration();
      setPrimaryBanner(response.result.mainBanner?.[bannerLang[locale]]);
      setSubBannerOne(response.result.subBanner1?.[bannerLang[locale]]);
      setSubBannerTwo(response.result.subBanner2?.[bannerLang[locale]]);
      setSubBannerThree(response.result.subBanner3?.[bannerLang[locale]]);
      setLoading(false);
    };

    getBanners();
  }, []);

  return (
    <>
      {loading ? (
        <div className="md:mt-5">
          <Skeleton height="400px" />
          <div className="flex gap-4 mt-4">
            <Skeleton height="200px" />
            <Skeleton height="200px" />
            <Skeleton height="200px" />
          </div>
        </div>
      ) : (
        <>
          <div
            className="md:mt-5 overflow-hidden primary-banner-responsive"
            style={{ maxHeight: "400px" }}
          >
            <AdvancedImage
              cldImg={cloudinaryInstance.image(primaryBanner).format("webp")}
              className="w-full"
            />
            {/* <BannerCarousel items={banners} /> */}
          </div>

          <div className="grid grid-nogutter gap-4 mt-4 overflow-hidden">
            {subBannerOne && (
              <div className="col-12 md:col" style={{ maxHeight: "200px" }}>
                <AdvancedImage
                  cldImg={cloudinaryInstance.image(subBannerOne).format("webp")}
                  className="w-full"
                />
              </div>
            )}
            {subBannerTwo && (
              <div className="col-12 md:col" style={{ maxHeight: "200px" }}>
                <AdvancedImage
                  cldImg={cloudinaryInstance.image(subBannerTwo).format("webp")}
                  className="w-full"
                />
              </div>
            )}

            {subBannerThree && (
              <div className="col-12 md:col" style={{ maxHeight: "200px" }}>
                <AdvancedImage
                  cldImg={cloudinaryInstance.image(subBannerThree).format("webp")}
                  className="w-full"
                />
              </div>
            )}
          </div>
          {/* <BestDeals /> */}
        </>
      )}
    </>
  );
};

export default PrimaryBanner;
